<div class="page-padding">
  <!--component setup panel-->
  <div class="panel">
    <div class="panel__header">
      <!--Main header-->
      <span class="panel__header__title">{{'Component Setup' | translate | async}}</span>
    </div>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{'Component Search' | translate | async}}</span>
      </div>
      <!--form-->
      <form class="header-form">


        <mat-form-field class="header-form-full-width">
          <input matInput name="EquipMake_" [(ngModel)]="EquipMake" #EquipMake_="ngModel" placeholder="{{'Equipment Make' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="EquipModel_" [(ngModel)]="EquipModel" #EquipModel_="ngModel"
            placeholder="{{'Equipment Model' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{'Component Type' | translate | async}}" name="componentType_" [(ngModel)]="ComponentType"
            #componentType_="ngModel" (selectionChange)="changeComponentType($event.value)">
            <mat-option [value]="type.Title" *ngFor="let type of componentTypeList">
              {{type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="ComponentMake_" [(ngModel)]="ComponentMake" #ComponentMake_="ngModel"
            placeholder="{{'Component Make' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="ComponentDescription_" [(ngModel)]="ComponentDescription"
            #ComponentDescription_="ngModel" placeholder="{{'Component Description' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="ComponentId_" [(ngModel)]="ComponentId" #ComponentId_="ngModel" placeholder="{{'Part No' | translate | async}}">
        </mat-form-field>
        <mat-form-field class="header-form-full-width">
          <input matInput name="Pitch_" [(ngModel)]="Pitch" #Pitch_="ngModel" placeholder="{{'Pitch' | translate | async}}">
        </mat-form-field>
        <div class="bottom-row">

          <a class="button"><span class="button__text" (click)="componentSetupFormRest()">{{'Reset' | translate | async}}</span></a>
          <a class="button button--primary">
            <i class="material-icons button__icon"></i><span class="button__text"
              (click)="GetComponentListForGrid()">{{'Search' | translate | async}}</span>
          </a>
          <a class="button button--primary">
            <i class="material-icons button__icon"></i><span class="button__text" (click)="exportAsXLSX()">
              {{'Export to Excel' | translate | async}}
            </span>
          </a>

        </div>
      </form>

      <!--Table View-->

      <div *ngIf="showTableView" class="table-container ">
        <!--Table-->
        <mat-table class=" mat-elevation-z8" #table [dataSource]="dataSource" matSort style="width: 100%;">

          <ng-container matColumnDef="ComponentId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Part No' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ComponentId}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ComponentDescription">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Component Description' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ComponentDescription}} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="ComponentType">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Component Type' | translate | async}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ComponentType}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Pitch">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Pitch' | translate | async}} ({{userUOM}}) </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.Pitch}} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="ComponentMake">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Component Make' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ComponentMake}} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="EquipModel">
            <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 35%;">
              {{'Equipment Model' | translate | async}}
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="Model-cell" style="min-width: 35%;"> {{element.EquipModel}} </mat-cell>
          </ng-container>


          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns; " [ngClass]="{ 'selected': row === selectedRow }"
            (click)="selectRow(row)"></mat-row>
        </mat-table>
      </div>
      <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner>

    </mat-card>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{'Component' | translate | async}}</span>
      </div>

      <!--form-->
      <form class="header-form">
        <mat-form-field class="header-form-full-width">
          <input matInput name="partNo_" [(ngModel)]="partNo" #partNo_="ngModel" placeholder="{{'Part No' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="componentPitch_" [(ngModel)]="componentPitch" #componentPitch_="ngModel" placeholder="{{'Pitch' | translate | async}} ({{userUOM}})">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <input matInput name="componentName_" [(ngModel)]="componentName" #componentName_="ngModel"
            placeholder="{{'Component Name' | translate | async}}">
        </mat-form-field>

        <mat-form-field class="header-form-full-width">
          <mat-select placeholder="{{'Sub System/Component Type' | translate | async}}" name="comSubType" [(ngModel)]="comSubType"
            (selectionChange)="SelectedComponentTypeValue($event)">
            <mat-option [value]="type.Id" *ngFor="let type of componentTypeList">
              {{type.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>

    </mat-card>

    <!--Extra Details-->
    <mat-card class="panel_search mat-card">




      <mat-tab-group (selectedTabChange)="selectedTabValue($event)">
        <mat-tab label="Component Details"> <!--sub header-->

          <form class="header-form">
            <div class="flex-row-shared">
              <!--text area-->
              <mat-form-field class="component-note-input-container">
                <textarea rows="2" cols="50" matInput name="compart_note_" [(ngModel)]="compart_note"
                  #compart_note_="ngModel" placeholder="{{'Component Note' | translate | async}}"></textarea>
              </mat-form-field>

              <mat-form-field class="shared-component-e-d-slect-containers">
                <input matInput name="smcs_code_" [(ngModel)]="smcs_code" #smcs_code_="ngModel"
                  placeholder="{{'SMCS Job Code' | translate | async}}">
              </mat-form-field>

              <mat-form-field class="mat-form-width-shared ">
                <input matInput name="budget_life_" [(ngModel)]="budget_life" #budget_life_="ngModel"
                  placeholder="{{'Budget Life (Hours)' | translate | async}}" required>
              </mat-form-field>
              <mat-form-field class="mat-form-width-shared ">
                <input matInput name="propel_budget_life_" [(ngModel)]="Propel_budget_life" #budget_life_="ngModel"
                  placeholder="{{'Propel Budget Life (Hours)' | translate | async}}">
              </mat-form-field>

              <mat-form-field class="mat-form-width-shared ">
                <input matInput name="distanceBudget_" [(ngModel)]="distanceBudget" #distanceBudget_="ngModel"
                  placeholder="{{'Distance Budget' | translate | async}}">
              </mat-form-field>

              <a class="button button--primary" style="margin-right: 20px;    width: 20%; margin-left: 20px;"
                [hidden]="!isRowClick">
                <i class="material-icons button__icon" [hidden]="!isRowClick"></i><span class="button__text"
                  (click)="openUSCOPartUpdateDialog()" [hidden]="!isRowClick">
                  {{'Populate from USCO' | translate | async}}
                </span>
              </a>

            </div>

            <div class="flex-row-shared">

              <!--model select-->
              <mat-form-field class="shared-component-e-d-slect-containers">
                <mat-select placeholder="{{'Model' | translate | async}}" name="moduleid_" [(ngModel)]="moduleid" #moduleid_="ngModel" required>
                  <mat-option [value]="model.Id" *ngFor="let model of filteredModels">
                    {{model.Title}}
                  </mat-option>
                </mat-select>
                <mat-error>{{'Please select a Model' | translate | async}}</mat-error>
              </mat-form-field>
              <div>
                <a class="apply-module-container-add-button button button--primary">
                  <i class="material-icons button__icon" style="margin-right: 0px"></i><span class="button__text"
                    (click)="addModel(0)">{{'Add' | translate | async}}</span>
                </a>
              </div>
              <mat-form-field style="width:100%;overflow-y: auto; max-height: 100px">
                <mat-chip-list #chipList>
                  <mat-chip *ngFor="let title of modelNameID" [selectable]="selectable" [removable]="removable"
                    (removed)="removeModel(title)">
                    {{title}}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip>
                  <input placeholder="{{'Apply Models' | translate | async}}..." [matChipInputFor]="chipList"
                    [matChipInputAddOnBlur]="addOnBlur" />
                </mat-chip-list>
              </mat-form-field>
            </div>
          </form>
          <div class="flex-row-box ">
            <div class="flex-column-box flex-column-shared">
              <div class="apply-module-container">
                <mat-form-field style="width:60%;">
                  <mat-select placeholder="{{'U/C Make' | translate | async}}" name="make_auto" [(ngModel)]="make_auto" required>
                    <mat-option [value]="type.Id" *ngFor="let type of makeList">
                      {{type.Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error>{{'Please select a U/C Make' | translate | async}}</mat-error>
                </mat-form-field>
                
                <div *ngIf="!isTypeEqBar">
                  <mat-form-field style="width:60%; margin-left: 30px;">
                    <mat-select placeholder="{{'Default Tool Used' | translate | async}}" name="tool_auto" [(ngModel)]="tool_auto"
                      (change)="changeTool($event.value)" required>
                      <mat-option [value]="type.ToolId" *ngFor="let type of MeasurementToolsViewModel">
                        {{type.ToolName}}
                      </mat-option>
                    </mat-select>
                    <mat-error>{{'Please select a Tool Used' | translate | async}}</mat-error>
                  </mat-form-field>
                </div>
                <!--mat chip-->

                <!--end mat chip-->
              </div>

              <div class="flex-box-align">
                <div class="flex-column-shared flex-align-column-shared">
                  <a class="button button--primary">
                    <i class="material-icons button__icon"></i><span class="button__text"
                      (click)="openSaveCompImageUpload()">
                      <span *ngIf="isStandardComp">
                        {{'Add Component Image' | translate | async}}
                      </span>
                      <span *ngIf="!isStandardComp">
                        {{'Replace Component Image' | translate | async}}
                      </span>
                    </span>
                  </a>
                  <span *ngIf="isStandardComp" style="font-weight: bold;">{{'Component Type Standard Image' | translate | async}}</span>
                  <img style="width:100px; height:100px" *ngIf="attachment_comp" [src]="sanitize(attachment_comp)">
                </div>

                <!--<div class="flex-column-shared flex-align-column-shared">
                  <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
                      (click)="openSaveCompImage()">Add Testing Point Image</span></a>
                      <span *ngIf="isStandard==true"  style="font-weight: bold;">Component Type Standard Image</span>
                  <img style="width:100px; height:100px" *ngIf="attachment" [src]="sanitize(attachment)">
                </div>-->

              </div>
            </div>

            <div class="border-box-container">

              <div class="border-box">

                <mat-form-field class="mat-form-width-shared ">
                  <input matInput name="track_compart_worn_calc_method_name_"
                    [(ngModel)]="track_compart_worn_calc_method_name" #track_compart_worn_calc_method_name_="ngModel"
                    placeholder="{{'Method of Calculation' | translate | async}}" readonly>
                </mat-form-field>

                <mat-form-field class="mat-form-width-shared ">
                  <input matInput name="modified_user_" [(ngModel)]="modified_user" #modified_user_="ngModel"
                    placeholder="{{'Modified User' | translate | async}}" readonly>
                </mat-form-field>

                <mat-form-field class="mat-form-width-shared ">
                  <input matInput name="modified_date_short_" [(ngModel)]="modified_date_short"
                    #modified_date_short_="ngModel" placeholder="{{'Modified Date' | translate | async}}" readonly>
                </mat-form-field>


              </div>

              <a class="button button--primary" style="margin-top:10px;">
                <i class="material-icons button__icon"></i><span class="button__text" (click)="navigateToWornLimit()">
                  {{'Setup/Edit Percentage Worn Limits' | translate | async}}
                </span>
              </a>

            </div>

          </div>


          <!--add / update /delete-->

          <div class="a-u-d-main-container">

            <div class="a-u-d-top-container">

              <mat-checkbox style="margin-right: 20px;" [(ngModel)]="checked">{{'Component is a Child of' | translate | async}}</mat-checkbox>

              <!-- <mat-form-field style="width: 350px">
                <mat-select placeholder="Select Parent Component" name="parentCompartID" [(ngModel)]="parentCompartID"> -->
                  <!-- <mat-option *ngFor="let item of  _componentservice.componentImage" [value]="item.compartid_auto" -->
                  <!-- <mat-option *ngFor="let item of  GetComponentImage" [value]="item.compartid_auto"
                    [hidden]="!checked">
                    {{ item.compartid+'- '+item.compart }}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->


              <mat-form-field class="search-input" appearance="outline" style="width: 33% !important">
                <mat-icon matPrefix style=" color: #d7cfcf;
                  font-size: 20px; ">search</mat-icon>
                <input type="text" placeholder="{{'Select Parent Component' | translate | async}}"  (input)="MakeChanged($event)" matInput [matAutocomplete]="autoMake"
                  [(ngModel)]="parentCompartIDText" #autoCompleteInput1="matAutocompleteTrigger">
                <mat-autocomplete [(ngModel)]="parentCompartID" #model_auto="ngModel" #autoMake="matAutocomplete"
                  (optionSelected)="onSelectMake($event.option)">
                  <mat-option *ngFor="let item of  getFilterCompartList" [value]="item.compartid_auto"
                    [hidden]="!checked">
                    {{ item.compartid+'- '+item.compart }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

            </div>

            <div class="a-u-d-down-container">
              <button mat-raised-button color="warn" (click)="save_updateCompart()" *ngIf="isNew" [disabled]="loading" [class.loading]="loading">{{ "Add" | translate | async }}</button>
              
              <a class="button button--primary" style="margin-right: 20px;" [hidden]="isNew">
                <i class="material-icons button__icon" [hidden]="isNew"></i><span class="button__text"
                  (click)="save_updateCompart()" [hidden]="isNew">
                  {{'Update' | translate | async}}
                </span>
              </a>
              <a class="button button--primary" [hidden]="isNew">
                <i class="material-icons button__icon" [hidden]="isNew">
                </i><span class="button__text" [hidden]="isNew" (click)="delete_comaprt()">
                  {{'Delete' | translate | async}}
                </span>
              </a>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Component Extra Details">
          <div class="row" style="padding: 10px;">
            <div class="col-lg-6">
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="CasePart_" [(ngModel)]="CaseParTNumber" #CasePart_="ngModel"
                    placeholder="{{'Case Part #' | translate | async}}">
                </mat-form-field>
              </div>
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="BERCO_" [(ngModel)]="BERCOPartNumber" #BERCO_="ngModel"
                    placeholder="{{'BERCO Part #' | translate | async}}">
                </mat-form-field>

              </div>
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="KTSU_" [(ngModel)]="KTSUPartNumber" #KTSU_="ngModel" placeholder="{{'KTSU Part #' | translate | async}}">
                </mat-form-field>

              </div>
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="OEM_" [(ngModel)]="OEMPartNumber" #OEM_="ngModel" placeholder="{{'OEM Part #' | translate | async}}">
                </mat-form-field>

              </div>
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="ITM_" [(ngModel)]="ITMPartNumber" #ITM_="ngModel" placeholder="{{'ITM Part #' | translate | async}}">
                </mat-form-field>


              </div>
              <div class="col-lg-12">
                <mat-form-field class="mat-width">
                  <input matInput name="ITR_" [(ngModel)]="ITRPartNumber" #ITR_="ngModel" placeholder="{{'ITR Part #' | translate | async}}">
                </mat-form-field>

              </div>
            </div>

            <div class="col-lg-6">
              <div class="col-lg-6">
                <div class="col-lg-12">
                  <mat-form-field class="mat-width">
                    <input type="number" matInput name="Cost_" [(ngModel)]="Cost" #Cost_="ngModel" placeholder="{{'Cost' | translate | async}}">
                  </mat-form-field>

                  <mat-form-field class="mat-width">
                    <input type="number" matInput name="Quantity_" [(ngModel)]="QuantityInStock" #Quantity_="ngModel"
                      placeholder="{{'Quantity in Stock' | translate | async}}">
                  </mat-form-field>


                </div>
              </div>
              <div class="col-lg-6">
                <div class="col-lg-12">
                  <mat-form-field class="mat-width-sec">
                    <mat-select placeholder="{{'Part Line' | translate | async}}" name="partLine" [(ngModel)]="PartLineId">
                      <mat-option *ngFor="let item of partLine" [value]="item.id">
                        {{ item.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </div>
              </div>
            </div>


          </div>
          <div class="row">
            <div class="a-u-d-down-container">
              <a class="button button--primary" style="margin-right: 20px;">
                <i class="material-icons button__icon"></i>
                <span class="button__text" (click)="save_updateCompart()"> {{'Update' | translate | async}} </span>
              </a>
            </div>
          </div>

        </mat-tab>
        <mat-tab label="Sprocket Hardware" *ngIf="comSubType==236">
          <div class="row" style="padding: 15px;">
            <div class="col-lg-3">
              <mat-form-field class="mat-width-sec">
                <input type="text" matInput name="SCasePart_" [(ngModel)]="SCasePart" #SCasePart_="ngModel"
                  placeholder="{{'Case Part #' | translate | async}}">
              </mat-form-field>

            </div>
            <div class="col-lg-3">
              <mat-form-field class="mat-width-sec">
                <input type="text" matInput name="SBerco_" [(ngModel)]="SBerco" #SBerco_="ngModel"
                  placeholder="{{'Berco Part #' | translate | async}}">
              </mat-form-field>


            </div>
            <div class="col-lg-3">
              <mat-form-field class="mat-width-sec">
                <input type="text" matInput name="Description_" [(ngModel)]="SDescription" #Description_="ngModel"
                  placeholder="{{'Description' | translate | async}}">
              </mat-form-field>
            </div>
            <div class="col-lg-3">
              <mat-form-field class="mat-width-sec">
                <input type="number" matInput name="SQuantity_" [(ngModel)]="SQuantity" #SQuantity_="ngModel"
                  placeholder="{{'Quantity' | translate | async}}">
              </mat-form-field>


            </div>
            <a class="button button--primary" style="margin-right: 20px; float: right;">
              <i class="material-icons button__icon"></i>
              <span class="button__text" (click)="update_sproket(1)">{{'Add' | translate | async}}</span>
            </a>
          </div>

          <div *ngIf="showTableViewSProket" class="table-container ">
            <!--Table-->
            <mat-table class=" mat-elevation-z8" #table [dataSource]="dataSource_Sproket" matSort style="width: 100%;">
              <ng-container matColumnDef="CasePart">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Case Part#' | translate | async}} </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-form-field class="mat-width" >
                    <input type="text" matInput name="SCasePart_" [(ngModel)]="element.CasePartNumberSproket"
                      #SCasePart_="ngModel" (blur)="update_sproket_Data(2,element)">
                  </mat-form-field>

                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Berco">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Berco#' | translate | async}} </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-form-field class="mat-width" >
                    <input type="text" matInput name="SBerco_" [(ngModel)]="element.BercoPartNumberSproket"
                      #SBerco_="ngModel"   (blur)="update_sproket_Data(2,element)">
                    </mat-form-field>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Desc">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Description' | translate | async}} </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-form-field class="mat-width" >
                    <input type="text" matInput name="Description_" [(ngModel)]="element.Description"
                      #Description_="ngModel"   (blur)="update_sproket_Data(2,element)">
                    </mat-form-field>
                </mat-cell>
              </ng-container>
              <ng-container matColumnDef="Quantity">
                <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Quantity' | translate | async}} </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <mat-form-field class="mat-width" >
                    <input type="number" matInput name="SQuantity_" [(ngModel)]="element.Quantity" #SQuantity_="ngModel"
                        (blur)="update_sproket_Data(2,element)">
                    </mat-form-field>
                </mat-cell>
              </ng-container>
              <mat-header-row *matHeaderRowDef="displayedColumns_Sproket"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns_Sproket; "
                [ngClass]="{ 'selected': row === selectedRowSprocket }" ></mat-row>
            </mat-table>
          </div>
          <!-- <mat-spinner class="loading-spinner" *ngIf="tableDataLoading"></mat-spinner> -->
        </mat-tab>
      </mat-tab-group>
    </mat-card>

    <!--MEASURMENT DETAILS-->
    <mat-card class="panel_search mat-card" *ngIf="showMesurementTable">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{'Measurement Images' | translate | async}}</span>
      </div>

      <!--form-->
      <div class="btn-mesurement-add-container">
        <a class="button button--primary">
          <i class="material-icons button__icon"></i><span class="button__text" (click)="openSaveMeasurement(0)">
            {{'Add Measurement Image' | translate | async}}
          </span>
        </a>
      </div>

      <mat-spinner class="loading-spinner" *ngIf="tableDataLoadingMesurementImage"></mat-spinner>

      <div class="table-container-mesurement-image mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource_measurements">

          <ng-container matColumnDef="Tool Name">
            <mat-header-cell *matHeaderCellDef> {{'Tool Name' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ToolName}} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="Title">
            <mat-header-cell *matHeaderCellDef> {{'Title' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.Title}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Image">
            <mat-header-cell *matHeaderCellDef> {{'Image' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <img style="width:100px; height: 100px" [src]="sanitize(element.ImageDataBase64)">
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Created Date">
            <mat-header-cell *matHeaderCellDef> {{'Created Date' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.CreatedDate}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns_measurements"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns_measurements;"
            [ngClass]="{'highlight': selectedRowIndex_ == row.id}" (click)="getrowMeasuremetDetails(row)"></mat-row>
        </mat-table>
      </div>
    </mat-card>
  </div>
</div>